/* eslint-disable no-param-reassign */
import React, { useState, useEffect } from 'react';
import Toast from 'react-bootstrap/Toast';
import Button from '@material-ui/core/Button';
import { Router, Route, Switch } from 'react-router-dom';
import queryString from 'query-string';
import axios from 'axios';
// import ip from 'ip';
import publicIp from 'public-ip';
import createBrowserHistory from 'history/createBrowserHistory';
import AccountRegister from './pages/AccountRegister';
import GroupRegister from './pages/GroupRegister';
import DepositRegister from './pages/DepositRegister';
import DepositSearch from './pages/DepositSearch';
import EmailChange from './pages/EmailChange';
import ForcePasswordChange from './pages/ForcePasswordChange';
import ForgotPassword from './pages/ForgotPassword';
import GochiHistorySearch from './pages/GochiHistorySearch';
import GochiMenuSearch from './pages/GochiMenuSearch';
import GochiMenuEventSearch from './pages/GochiMenuEventSearch';
import GochiEventSetting from './pages/GochiEventSetting';
import GochiEventSettingConnect from './pages/GochiEventSettingConnect';
import GochiChildFoodSearch from './pages/GochiChildFoodSearch';
import GroupSearch from './pages/GroupSearch';
import GroupGochiMenuSearch from './pages/GroupGochiMenuSearch';
import GroupAdd from './pages/GroupAdd';
import GroupIdentitySearch from './pages/GroupIdentitySearch';
import GroupLinkSearch from './pages/GroupLinkSearch';
import GroupShopSearch from './pages/GroupShopSearch';
import IdentitySearch from './pages/IdentitySearch';
import Login from './pages/Login';
import ManageNoticeSearch from './pages/ManageNoticeSearch';
import MessageSearch from './pages/MessageSearch';
import PasswordChange from './pages/PasswordChange';
import PreShopSearch from './pages/PreShopSearch';
import QrCodeIssue from './pages/QrCodeIssue';
import QrCodePrint from './pages/QrCodePrint';
import RegisterStripe from './pages/RegisterStripe';
import GroupRegisterStripe from './pages/GroupRegisterStripe';
import Release from './pages/Release';
import ReleaseSearch from './pages/ReleaseSearch';
import ReleaseStep from './pages/ReleaseStep';
import ReleaseGroup from './pages/ReleaseGroup';
import ReleaseStepReview from './pages/ReleaseReviewIdentity';
import ReleaseStepReviewGroup from './pages/ReleaseReviewIdentityGroup';
import ReleaseStepMenuSetting from './pages/ReleaseSettingMenu';
import ReleaseStepUnregister from './pages/ReleaseStepUnregister';
import ResetComplete from './pages/ResetComplete';
import ResetMailSending from './pages/ResetMailSending';
import ResetPassword from './pages/ResetPassword';
import ShopSearch from './pages/ShopSearch';
import ListBudget from './pages/ListBudget';
import ListSupplyGochi from './pages/ListSupplyGochi';
import SummaryReportForSecretariat from './pages/SummaryReportForSecretariat';
// import SummaryReportForGroup from './pages/SummaryReportForGroup';
import SmsAuth from './pages/SmsAuth';
import UnregisteredShopSearch from './pages/UnregisteredShopSearch';
import UserSearch from './pages/UserSearch';
import CsvShop from './pages/CsvShop';
import CreateSecretMenu from './pages/CreateSecretMenu';
import RelationShop from './pages/RelationShop';
import GenerateCode from './pages/GenerateCode';
import DownloadRepor from './pages/DownloadRepor';
import ChargeEventSearch from './pages/ChargeEventSearch';
import GochiImportFile from './pages/GochiImportFile';
import AutomaticStatistics from './pages/AutomaticStatistics';
import AutomaticStatisticsConfirm from './pages/AutomaticStatisticsConfirm';
import Home from './pages/Home';
import GochiHistorySearchShop from './pages/GochiHistorySearchShop';
import ListBookingShop from './pages/ListBookingShop';
import InfoPaymentsShop from './pages/InfoPaymentsShop';
import ShopSearchShop from './pages/ShopSearchShop';
import GochiMenuSearchShop from './pages/GochiMenuSearchShop';
import NotificationsShop from './pages/NotificationsShop';
import PostsShop from './pages/PostsShop';
import VideoShop from './pages/VideoShop';
import RegisterStripeShop from './pages/RegisterStripeShop';
import SettingsShop from './pages/SettingsShop';
import DownloadQrShop from './pages/DownloadQrShop';
import PasswordChangeShop from './pages/PasswordChangeShop';
import EmailChangeShop from './pages/EmailChangeShop';
import TicketSearchShop from './pages/TicketSearchShop';
import ChangeTicketGochiSearch from './pages/ChangeTicketGochiSearch';
import ChangeTicketMenuSearch from './pages/ChangeTicketMenuSearch';
import GroupSearchGroup from './pages/GroupSearchGroup';
import GroupShopSearchGroup from './pages/GroupShopSearchGroup';
import HomeGroup from './pages/HomeGroup';
import SummaryReportGroup from './pages/SummaryReportGroup';
import GochiHistorySearchGroup from './pages/GochiHistorySearchGroup';
import '../stylesheets/iconFonts.css';
import '../stylesheets/icons.css';
import ShopSearchGroup from './pages/ShopSearchGroup';
import GochiMenuSearchGroup from './pages/GochiMenuSearchGroup';
import ListSupplyGochiGroup from './pages/ListSupplyGochiGroup';
import ListBookingGroup from './pages/ListBookingGroup';
import ListBooking from './pages/ListBooking';
import PostsGroup from './pages/PostsGroup';
import NotificationsGroup from './pages/NotificationsGroup';
import VideoGroup from './pages/VideoGroup';
import SettingsGroup from './pages/SettingsGroup';
import RegisterStripeGroup from './pages/RegisterStripeGroup';
import InfoPaymentsGroup from './pages/InfoPaymentsGroup';
import GochiCodeGroup from './pages/GochiCodeGroup';
import {
  askForPermissioToReceiveNotifications,
  onMessageListener
} from '../firebase/firebaseInit';
import ShashokuTicketSearch from './pages/ShashokuTicketSearch';
import ShashokuBudgetSearch from './pages/ShashokuBudgetSearch';
import Maintain from './pages/Maintain';
import CsvMenu from './pages/CsvMenu';
import StripeChargeEventSearch from './pages/StripeChargeEventSearch';
import GiftCard from './pages/GiftCard';
import ServerError from './pages/ServerError';
import BudgetEditGroup from './pages/BudgetEditGroup';
import GochiIssuance from './pages/GochiIssuance';
import ShashokuTicketUsedByAdminSearch from './pages/ShashokuTicketUsedByAdminSearch';
import InvoiceConfirmShop from './pages/InvoiceConfirmShop';
import InvoiceHistoryShop from './pages/InvoiceHistoryShop';
import ShopBatchRegistration from './pages/ShopBatchRegistration';
import UserBatchRegistration from './pages/UserBatchRegistration';
import GochiCodeShop from './pages/GochiCodeShop';
import ScanQrCodeUser from './pages/ScanQrCodeUser';
import GochiChargeBatchRegistration from './pages/GochiChargeBatchRegistration';
import GochiKidShop from './pages/GochiKidShop';
import GochiKidMenuShop from './pages/GochiKidMenuShop';
import GochiKidMenusAddShop from './pages/GochiKidMenusAddShop';
import ShopReportShop from './pages/ShopReportShop';
import SettingsGochiKidShop from './pages/SettingsGochiKidShop';
import GochiKidMenuSearchGroup from './pages/GochiKidMenuSearchGroup';
import GochiKidMenuSearchAddGroup from './pages/GochiKidMenuSearchAddGroup';
import GochiKidMenuSearch from './pages/GochiKidMenuSearch';
import GochiKidMenuSearchAdd from './pages/GochiKidMenuSearchAdd';
import IdentityUserKidSearch from './pages/IdentityUserKidSearch';
import ShashokuRefundExtraPaySearch from './pages/ShashokuRefundExtraPaySearch';
import AdminUseGochiKid from './pages/AdminUseGochiKid';
import ShashokuAdminSendMessageUser from './pages/ShashokuAdminSendMessageUser';
import GochiKidMenuFreeShop from './pages/GochiKidMenuFreeShop';
import GochiKidMenuFreeGroup from './pages/GochiKidMenuFreeGroup';
import UpdateAmountHistorySearchShop from './pages/UpdateAmountHistorySearchShop';
import UpdateAmountHistorySearchGroup from './pages/UpdateAmountHistorySearchGroup';
import UpdateAmountHistorySearch from './pages/UpdateAmountHistorySearch';
import GochiKidDonateSearchShop from './pages/GochiKidDonateSearchShop';
import GochiKidDonateSearchGroup from './pages/GochiKidDonateSearchGroup';
import GochiKidReceipt from './pages/GochiKidReceipt';
import UnusedGochiKidSearch from './pages/UnusedGochiKidSearch';

const history = createBrowserHistory();

const AppRoute = () => (
  <Switch>
    <Route exact path="/" component={Login} />
    <Route exact path="/accounts" component={AccountRegister} />
    <Route exact path="/deposit_register" component={DepositRegister} />
    <Route exact path="/deposits" component={DepositSearch} />
    <Route exact path="/email_change" component={EmailChange} />
    <Route exact path="/forgot_password" component={ForgotPassword} />
    <Route
      exact
      path="/force_passowrd_change"
      component={ForcePasswordChange}
    />
    <Route exact path="/gochis" component={GochiHistorySearch} />
    <Route exact path="/groups" component={GroupSearch} />
    <Route exact path="/group_gochi_menus" component={GroupGochiMenuSearch} />
    <Route exact path="/group_add" component={GroupAdd} />
    <Route exact path="/group_identities" component={GroupIdentitySearch} />
    <Route exact path="/group_links" component={GroupLinkSearch} />
    <Route exact path="/group_shops" component={GroupShopSearch} />
    <Route exact path="/gochi_menus" component={GochiMenuSearch} />
    <Route exact path="/gochi_menus_group" component={GochiMenuSearchGroup} />
    <Route exact path="/supply_gochi_group" component={ListSupplyGochiGroup} />
    <Route exact path="/list_booking_group" component={ListBookingGroup} />
    <Route exact path="/list_booking" component={ListBooking} />
    <Route exact path="/gochi_menus_event" component={GochiMenuEventSearch} />
    <Route exact path="/register_group" component={GroupRegister} />
    <Route exact path="/release_group" component={ReleaseGroup} />
    <Route
      exact
      path="/release_group_review"
      component={ReleaseStepReviewGroup}
    />
    <Route exact path="/gochi_event_setting" component={GochiEventSetting} />
    <Route
      exact
      path="/gochi_menus_event/:menuId/gochi_event"
      component={GochiEventSettingConnect}
    />
    <Route
      exact
      path="/gochi_child_food_list"
      component={GochiChildFoodSearch}
    />
    <Route exact path="/identities" component={IdentitySearch} />
    <Route exact path="/login" component={Login} />
    <Route exact path="/messages" component={MessageSearch} />
    <Route exact path="/passowrd_change" component={PasswordChange} />
    <Route exact path="/register_stripe" component={RegisterStripe} />
    <Route exact path="/shops" component={ShopSearch} />
    <Route exact path="/list_budget" component={ListBudget} />
    <Route exact path="/list_supply_gochi" component={ListSupplyGochi} />
    <Route exact path="/shops_group" component={ShopSearchGroup} />
    <Route exact path="/pre_shops" component={PreShopSearch} />
    <Route exact path="/qr_issue" component={QrCodeIssue} />
    <Route exact path="/qr_print" component={QrCodePrint} />
    <Route exact path="/release" component={Release} />
    <Route exact path="/releases" component={ReleaseSearch} />
    <Route exact path="/release_step" component={ReleaseStep} />
    <Route exact path="/release_review" component={ReleaseStepReview} />
    <Route exact path="/menu_setting" component={ReleaseStepMenuSetting} />
    <Route
      exact
      path="/group_register_stripe"
      component={GroupRegisterStripe}
    />
    <Route
      exact
      path="/release_step_unregister"
      component={ReleaseStepUnregister}
    />
    <Route exact path="/reset_mail_sending" component={ResetMailSending} />
    <Route exact path="/reset_password/:cognitoId" component={ResetPassword} />
    <Route exact path="/reset_complete" component={ResetComplete} />
    <Route exact path="/sms_auth" component={SmsAuth} />
    <Route exact path="/manage_notices" component={ManageNoticeSearch} />
    <Route
      exact
      path="/summary_report_secretariat"
      component={SummaryReportForSecretariat}
    />
    <Route exact path="/gochis_import_file" component={GochiImportFile} />
    {/* <Route
      exact
      path="/summary_report_group"
      component={SummaryReportForGroup}
    /> */}
    <Route
      exact
      path="/unregistered_shops"
      component={UnregisteredShopSearch}
    />
    <Route exact path="/users" component={UserSearch} />
    <Route exact path="/csv-shop" component={CsvShop} />
    <Route exact path="/automatic-statistics" component={AutomaticStatistics} />
    <Route
      exact
      path="/automatic-statistics-confirm"
      component={AutomaticStatisticsConfirm}
    />
    <Route exact path="/csv-menu" component={CsvMenu} />
    <Route exact path="/create_secret_menu" component={CreateSecretMenu} />
    <Route exact path="/relation-shop" component={RelationShop} />
    <Route exact path="/generate-code" component={GenerateCode} />
    <Route exact path="/download-report" component={DownloadRepor} />
    <Route exact path="/charge_event" component={ChargeEventSearch} />
    <Route
      exact
      path="/stripe_charge_event"
      component={StripeChargeEventSearch}
    />
    <Route exact path="/home" component={Home} />
    <Route exact path="/gochis_shop" component={GochiHistorySearchShop} />
    <Route exact path="/list_booking_shop" component={ListBookingShop} />
    <Route exact path="/info_payments_shop" component={InfoPaymentsShop} />
    <Route exact path="/shops_shop" component={ShopSearchShop} />
    <Route exact path="/gochi_menus_shop" component={GochiMenuSearchShop} />
    <Route exact path="/notifications_shop" component={NotificationsShop} />
    <Route exact path="/posts_shop" component={PostsShop} />
    <Route exact path="/video_shop" component={VideoShop} />
    <Route exact path="/register_stripe_shop" component={RegisterStripeShop} />
    <Route exact path="/settings_shop" component={SettingsShop} />
    <Route exact path="/download_qr_shop" component={DownloadQrShop} />
    <Route exact path="/change_mail_shop" component={EmailChangeShop} />
    <Route exact path="/change_pass_shop" component={PasswordChangeShop} />
    <Route exact path="/tickets_shop" component={TicketSearchShop} />
    <Route exact path="/invoice_shop" component={InvoiceConfirmShop} />
    <Route exact path="/invoice_history_shop" component={InvoiceHistoryShop} />
    <Route exact path="/scan_qrcode_user" component={ScanQrCodeUser} />
    <Route
      exact
      path="/change_ticket_gochi"
      component={ChangeTicketGochiSearch}
    />
    <Route
      exact
      path="/change_ticket_menu"
      component={ChangeTicketMenuSearch}
    />
    <Route exact path="/gochi_code_shop" component={GochiCodeShop} />
    <Route exact path="/gochi_kid_shop" component={GochiKidShop} />
    <Route exact path="/gochi_kid_menu_shop" component={GochiKidMenuShop} />
    <Route
      exact
      path="/gochi_kid_menu_free_shop"
      component={GochiKidMenuFreeShop}
    />
    <Route
      exact
      path="/gochi_kid_menus_add_shop"
      component={GochiKidMenusAddShop}
    />
    <Route exact path="/shop_report_shop" component={ShopReportShop} />
    <Route
      exact
      path="/settings_gochi_kid_shop"
      component={SettingsGochiKidShop}
    />

    {/* Group's route */}
    <Route exact path="/groups_group" component={GroupSearchGroup} />
    <Route exact path="/home_group" component={HomeGroup} />
    <Route exact path="/group_shops_group" component={GroupShopSearchGroup} />
    <Route exact path="/summary_report_group" component={SummaryReportGroup} />
    <Route exact path="/gochis_group" component={GochiHistorySearchGroup} />
    <Route exact path="/posts_group" component={PostsGroup} />
    <Route exact path="/notifications_group" component={NotificationsGroup} />
    <Route exact path="/video_group" component={VideoGroup} />
    <Route exact path="/settings_group" component={SettingsGroup} />
    <Route exact path="/deposit_group" component={InfoPaymentsGroup} />
    <Route exact path="/gochi_code_group" component={GochiCodeGroup} />
    <Route
      exact
      path="/shop_batch_registration"
      component={ShopBatchRegistration}
    />
    <Route
      exact
      path="/gochi_charge_batch_registration"
      component={GochiChargeBatchRegistration}
    />
    <Route
      exact
      path="/user_batch_registration"
      component={UserBatchRegistration}
    />
    <Route
      exact
      path="/register_stripe_group"
      component={RegisterStripeGroup}
    />
    <Route exact path="/shashoku_tickets" component={ShashokuTicketSearch} />
    <Route
      exact
      path="/shashoku_tickets_used_by_admin"
      component={ShashokuTicketUsedByAdminSearch}
    />
    <Route exact path="/shashoku_budgets" component={ShashokuBudgetSearch} />
    <Route
      exact
      path="/shashoku_refund_extra_pay"
      component={ShashokuRefundExtraPaySearch}
    />
    <Route
      exact
      path="/shashoku_admin_send_message_to_user"
      component={ShashokuAdminSendMessageUser}
    />
    <Route exact path="/maintain" component={Maintain} />
    <Route exact path="/server-error" component={ServerError} />
    <Route exact path="/giftcard" component={GiftCard} />
    <Route exact path="/budget_edit" component={BudgetEditGroup} />
    <Route exact path="/gochi_issuance" component={GochiIssuance} />
    <Route
      exact
      path="/gochi_kid_menus_group"
      component={GochiKidMenuSearchGroup}
    />
    <Route
      exact
      path="/gochi_kid_menu_free_group"
      component={GochiKidMenuFreeGroup}
    />
    <Route
      exact
      path="/gochi_kid_menus_add_group"
      component={GochiKidMenuSearchAddGroup}
    />
    <Route exact path="/gochi_kid_menus" component={GochiKidMenuSearch} />
    <Route
      exact
      path="/gochi_kid_menus_add"
      component={GochiKidMenuSearchAdd}
    />
    <Route exact path="/identity_user_kid" component={IdentityUserKidSearch} />
    <Route exact path="/admin_use_gochi_kid" component={AdminUseGochiKid} />
    <Route
      exact
      path="/update_amount_history"
      component={UpdateAmountHistorySearch}
    />
    <Route
      exact
      path="/update_amount_history_shop"
      component={UpdateAmountHistorySearchShop}
    />
    <Route
      exact
      path="/update_amount_history_group"
      component={UpdateAmountHistorySearchGroup}
    />
    <Route exact path="/donations_shop" component={GochiKidDonateSearchShop} />
    <Route
      exact
      path="/donations_group"
      component={GochiKidDonateSearchGroup}
    />
    <Route exact path="/gochi_kid_receipt" component={GochiKidReceipt} />
    <Route exact path="/unused_gochi_kid" component={UnusedGochiKidSearch} />
  </Switch>
);

const App = () => {
  // (async () => {
  //   let ipAddress = '';
  //   try {
  //     ipAddress = await publicIp.v4();
  //   } catch (e) {
  //     console.log(e);
  //   }
  //   axios.defaults.headers.get['ip-address'] = ipAddress;
  // })();

  axios.interceptors.request.use(
    async conf => {
      // you can add some information before send it.
      // conf.headers['Auth'] = 'some token'
      let ipAddress = '';
      try {
        ipAddress = await publicIp.v4();
      } catch (e) {
        console.log(e);
      }

      // eslint-disable-next-line no-param-reassign
      conf.headers['ip-address'] = ipAddress;
      conf.headers.accept = 'application/json';
      return conf;
    },
    error => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    response => {
      // alert permission with code 408 and account is SECRETARIAT_VIEWER
      if (response.status === 408) {
        alert('Your account does not have permission!');
      }
      return response;
    },
    err => {
      if (err.response && err.response.status === 503) {
        if (
          err.response.data.errorInfo &&
          err.response.data.errorInfo.content === 'SERVER_MAINTAIN'
        ) {
          history.push('/maintain');
        } else {
          history.push('/server-error');
        }
      }
      return Promise.reject(err);
    }
  );

  const url = window.location.search;
  const noti = queryString.parse(url);
  console.log('noti', noti);
  if (noti.notify === '1') {
    history.push(
      `/gochis_shop?notify=${Math.random()
        .toString(36)
        .substring(7)}`
    );
  }
  if (noti.notify === '2') {
    history.push(
      `/list_booking_shop?notify=${Math.random()
        .toString(36)
        .substring(7)}`
    );
  }
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({
    title: '',
    body: '',
    noticeType: ''
  });
  // send request pemission
  askForPermissioToReceiveNotifications();

  onMessageListener()
    .then(payload => {
      console.log(`onMessageListener:${JSON.stringify(payload)}`);
      setShow(true);
      const data = JSON.parse(payload.data.data);
      setNotification({
        title: data.title,
        body: data.body,
        noticeType: data.noticeType
      });
      console.log(`onMessageListener`);
      if (!('Notification' in window)) {
        console.log('This browser does not support system notifications');
      }
      // Let's check whether notification permissions have already been granted
      else if (Notification.permission === 'granted') {
        // If it's okay let's create a notification
        const notificationOptions = {
          title: data.title,
          body: data.body,
          noticeType: data.noticeType
        };
        const notificationLocal = new Notification(
          data.title,
          notificationOptions
        );
        notificationLocal.onclick = event => {
          event.preventDefault(); // prevent the browser from focusing the Notification's tab
          history.push(
            `/gochis_shop?notify=${Math.random()
              .toString(36)
              .substring(7)}`
          );
          setShow(false);
          notificationLocal.close();
        };
      }
    })
    .catch(err => {
      console.log(`Error: ${JSON.stringify(err)}`);
    });

  const notificationOnClicked = () => {
    console.log('notificationOnClicked');
    if (notification.noticeType === 'NOTICE_CREATE_UPDATE_GOCHI') {
      history.push(
        `/gochis_shop?notify=${Math.random()
          .toString(36)
          .substring(7)}`
      );
    }
    if (notification.noticeType === 'NOTICE_CREATE_BOOKING_GOCHI') {
      history.push(
        `/list_booking_shop?notify=${Math.random()
          .toString(36)
          .substring(7)}`
      );
    }
    setShow(false);
  };

  useEffect(() => {
    const searchLocation = window.location.search;
    const params = new URLSearchParams(searchLocation);
    const notify = params.get('notify');
    console.log('componentDidMount:', notify);
    if (notify === 1) {
      history.push(
        `/gochis_shop?notify=${Math.random()
          .toString(36)
          .substring(7)}`
      );
    }
    if (notify === 2) {
      history.push(
        `/list_booking_shop?notify=${Math.random()
          .toString(36)
          .substring(7)}`
      );
    }
  }, []);

  return (
    <>
      <Toast
        onClose={() => setShow(false)}
        show={show}
        delay={3000}
        animation
        className="notifi"
        style={{
          position: 'fixed',
          top: 20,
          right: 20,
          minWidth: 200,
          backgroundColor: 'rgb(39, 91, 157)',
          borderRadius: 4,
          padding: 10,
          zIndex: 100,
          left: 20,
          webkitBoxShadow: '1px 1px 5px 2px rgba(0,0,0,0.39);',
          mozBoxShadow: '1px 1px 5px 2px rgba(0,0,0,0.39)',
          boxShadow: '1px 1px 5px 2px rgba(0,0,0,0.39)'
        }}
      >
        <Toast.Header closeButton={false}>
          <img
            src={`${process.env.PUBLIC_URL}/images/logo.png`}
            className="rounded mr-2"
            alt="ごちめし"
            style={{
              height: 25,
              marginRight: 10
            }}
          />
          <strong
            className="mr-auto"
            style={{
              position: 'absolute',
              color: 'white'
            }}
          >
            {notification.title}
          </strong>
          <Button
            style={{
              width: 20,
              minWidth: 40,
              position: 'absolute',
              top: 0,
              right: 0,
              zIndex: 2,
              color: 'white'
            }}
            onClick={() => setShow(false)}
          >
            x
          </Button>
        </Toast.Header>
        <Toast.Body
          style={{
            color: 'white'
          }}
        >
          {notification.body}
        </Toast.Body>
        <Button
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }}
          onClick={() => notificationOnClicked()}
        />
      </Toast>
      <Router history={history}>
        <Route component={AppRoute} />
      </Router>
    </>
  );
};
export default App;
